// determine if current page is active or not
export const getActive = (isStatic, pageSlug, router) => {
  if (isStatic !== false) {
    return isStatic == router.pathname.replace(/^\//g, "");
  } else {
    const slugs = [].concat(router.query.slug);
    const currentPath = slugs
      ? slugs.join("/")
      : router.asPath.replace(/^\//g, "");
    return currentPath == pageSlug;
  }
};

export const getStaticRoute = (name) => {
  switch (name) {
    default:
      return false;
  }
};

export const getDynamicRoute = (name) => {
  switch (name) {
    default:
      return false;
  }
};
